import { Card, SecondColumn, TwoColumn } from './styles';

const FullHeightTwoColumnLayout = ({ SecondColumnComp, CardContent, noCardPadding }) => {
	return (
		<TwoColumn>
			<Card noCardPadding={noCardPadding}>{CardContent}</Card>
			{SecondColumnComp && <SecondColumn>{SecondColumnComp}</SecondColumn>}
		</TwoColumn>
	);
};

export default FullHeightTwoColumnLayout;
